import { ModalBody, ModalHeader } from 'UIKit/AlchemyModal'
import FairnessSecurity from 'views/Commitments/section/FairnessSecurity'
import PaymentRules from 'views/Commitments/section/PaymentRules'
import { PAYMENT_MODAL_THEME } from 'views/Payment/MobilePayment/components/styles'
import { ICommitmentsControl } from 'views/Payment/MobilePayment/types'

const PaymentCommitments: React.FC<{
  commitmentsControl: ICommitmentsControl
}> = ({ commitmentsControl }) => {
  return (
    commitmentsControl?.isShowCommitment && (
      <>
        <ModalHeader
          useBackIcon
          hideClose
          hideStroke
          colorTheme={PAYMENT_MODAL_THEME}
          titleAlign={['center', 'center', 'center', 'left']}
          onBack={commitmentsControl.toggleCommitment}
          title={"HunnyPlay's Commitments"}
        />
        <ModalBody>
          <PaymentRules />
          <FairnessSecurity />
        </ModalBody>
      </>
    )
  )
}

export default PaymentCommitments
